function initFeaturedProductVariantsNav(section) {
  if (!section || section.dataset.fpvNavInit === 'true') return;

  var container = section.querySelector('[data-fpv-variants]');
  var nav = section.querySelector('[data-fpv-nav]');
  var prevBtn = section.querySelector('[data-fpv-prev]');
  var nextBtn = section.querySelector('[data-fpv-next]');

  if (!container || !nav || !prevBtn || !nextBtn) return;

  section.dataset.fpvNavInit = 'true';

  function getCards() {
    return Array.prototype.slice.call(container.querySelectorAll('.card-wrapper'));
  }

  function isScrollable() {
    return container.scrollWidth > container.clientWidth + 1;
  }

  function updateNavVisibility() {
    nav.hidden = !isScrollable();
  }

  function getActiveIndex(cards) {
    var scrollLeft = container.scrollLeft;

    for (var i = 0; i < cards.length; i++) {
      if (cards[i].offsetLeft + cards[i].offsetWidth > scrollLeft + 1) {
        return i;
      }
    }

    return cards.length - 1;
  }

  function scrollToIndex(index) {
    var cards = getCards();
    if (!cards.length) return;

    var targetIndex = Math.max(0, Math.min(index, cards.length - 1));
    cards[targetIndex].scrollIntoView({
      behavior: 'smooth',
      inline: 'start',
      block: 'nearest'
    });
  }

  prevBtn.addEventListener('click', function () {
    scrollToIndex(getActiveIndex(getCards()) - 1);
  });

  nextBtn.addEventListener('click', function () {
    scrollToIndex(getActiveIndex(getCards()) + 1);
  });

  updateNavVisibility();

  window.addEventListener('resize', updateNavVisibility);

  if (typeof ResizeObserver !== 'undefined') {
    var resizeObserver = new ResizeObserver(updateNavVisibility);
    resizeObserver.observe(container);

    container.querySelectorAll('img').forEach(function (image) {
      if (!image.complete) {
        image.addEventListener('load', updateNavVisibility, { once: true });
      }
    });
  }
}

function initAllFeaturedProductVariantsNav() {
  document.querySelectorAll('.featured-product-variants').forEach(initFeaturedProductVariantsNav);
}

document.addEventListener('DOMContentLoaded', initAllFeaturedProductVariantsNav);
document.addEventListener('shopify:section:load', function (event) {
  var section = event.target.querySelector('.featured-product-variants');

  if (!section && event.target.classList.contains('featured-product-variants')) {
    section = event.target;
  }

  if (section) {
    initFeaturedProductVariantsNav(section);
  }
});
